/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon64Regular = forwardRef('MathSumIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M12.623 14.994C9.333 12.324 11.22 7 15.46 7h37.04a1.5 1.5 0 1 1 0 3H15.46c-1.413 0-2.043 1.775-.945 2.665l19.523 15.84a4.5 4.5 0 0 1 0 6.99l-19.523 15.84c-1.098.89-.468 2.665.945 2.665h37.04a1.5 1.5 0 1 1 0 3H15.46c-4.239 0-6.127-5.324-2.836-7.994l19.524-15.841a1.5 1.5 0 0 0 0-2.33l-19.524-15.84Z" })));
});
